import { memo, useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import { isUndefined, noop } from 'lodash';

const LabelTag = ({ color, bgColor, labelName, icon, onClick, translateLabel = false }) => {
    const [labelTagColor, setLabelTagColor] = useState<string>();
    const [labelBgColor, setLabelBgColor] = useState<string>(bgColor);
    const { t } = useTranslation();

    const setColors = () => {
        let tmpBgColor;
        if (bgColor) {
            tmpBgColor = bgColor;
        } else {
            tmpBgColor = color.includes('rgba') ? color.slice(0, color.length - 2) + '0.1)' : color + '17';
        }

        setLabelTagColor(color);
        setLabelBgColor(tmpBgColor);
    };

    useEffect(setColors, [bgColor, color]);

    return (
        <p
            title={translateLabel ? t(labelName) : labelName}
            style={{ '--label-tag-color': labelTagColor, '--label-tag-bg-color': labelBgColor } as React.CSSProperties}
            className="crm-label-tag c-l-tag"
        >
            <button onClick={onClick}>{labelName}</button>
            {!isUndefined(icon) && icon}
        </p>
    );
};

LabelTag.propTypes = {
    color: PropTypes.string.isRequired,
    labelName: PropTypes.string.isRequired,
    icon: PropTypes.node,
    onClick: PropTypes.func,
    bgColor: PropTypes.string,
    translateLabel: PropTypes.bool,
};

LabelTag.defaultProps = {
    onClick: noop,
};

export default memo(LabelTag);
